import axios from 'axios';
import qs from 'qs';
import Cookies from 'universal-cookie';
import { setContext, captureMessage } from '@sentry/gatsby';
import { INSERT_PARTIAL_LEAD, NEXT_ID, GET_CALENDAR_INFO, APPOINTMENT, CALL_CENTER_APPOINTMENT, TIMEBLOCK, CONVERT_LEAD, STORE_APPOINTMENT, STORE_LEAD_CONVERT, SUBMIT_APPOINTMENT_ERROR, CLEAR_ERRORS, GET_ERRORS, RESET_RTA_DATA } from './types';
import { axiosNonAuthSuccessResponse, axiosSuccessResponse } from './account-actions';
import { eloquaTrackingUrl } from '../components/utilities/constants';

const pellaAPIURL = process.env.GATSBY_PELLA_API;

const config = {
	headers: {
		Authorization: 'Bearer ' + process.env.GATSBY_PELLA_RTA_API_TOKEN,
	},
};

var CancelToken = axios.CancelToken; //deprecated
let salesforceCancel;

const interceptorInstanceNonAuth = axios.create();
interceptorInstanceNonAuth.interceptors.response.use(axiosSuccessResponse, axiosNonAuthSuccessResponse);

// Oracle
export const insertPartialLead = (apptData) => (dispatch) => {
	dispatch(clearErrors());
	interceptorInstanceNonAuth
		.post(`${pellaAPIURL}/rta/sched/partial-lead`, apptData, config)
		// .post(`http://localhost:4000/rta/sched/partial-lead`, apptData, config)
		.then((res) =>
			dispatch({
				type: INSERT_PARTIAL_LEAD,
				payload: res.data,
			})
		)
		.catch((err) =>
			dispatch({
				type: GET_ERRORS,
				payload: err,
			})
		);
};
// END Oracle

// GET
export const nextId = () => (dispatch) => {
	dispatch(clearErrors());
	interceptorInstanceNonAuth
		.get(`${pellaAPIURL}/rta/v2/salesforce/create`, config)
		.then((res) =>
			dispatch({
				type: NEXT_ID,
				payload: res.data,
			})
		)
		.catch((err) =>
			dispatch({
				type: GET_ERRORS,
				payload: err,
			})
		);
};

export const randomId = () => {
	const numbers = '123456789';
	const characters = `abcdef${numbers}`;
	// Start with a number
	let result = numbers.charAt(Math.floor(Math.random() * numbers.length));
	for (let i = 0; i < 5; i++) {
		result += characters.charAt(Math.floor(Math.random() * characters.length));
	}
	// Ensure at least 1 character is in the result
	if (isNaN(result.substring(1))) {
		return result;
	} else {
		return randomId();
	}
};

export const getCalendar =
	(source, zipcode, type = 'home') =>
	(dispatch) => {
		dispatch(clearErrors());
		salesforceCancel && salesforceCancel();
		const cancelToken = {
			cancelToken: new CancelToken(function executor(c) {
				salesforceCancel = c;
			}),
		};
		const params = {
			Interface: source,
			Zip: zipcode,
			Type: type,
		};

		function calendarTimings() {
			const end = performance.now();
			const timing = (end - start) / 1000;
			if (timing >= 10) {
				setContext('Timeout', {
					timing: timing,
					params: params,
				});
				captureMessage(`RTA Alerts - Calendar Timing ${timing >= 45 ? 'Critical' : 'Slow'}`);
			}
		}

		function calendarError(params, err) {
			setContext('Error Data', {
				params: params,
				error: err,
			}),
				captureMessage('RTA Alerts - Calendar Error');
		}

		const start = performance.now();
		interceptorInstanceNonAuth
			.get(`${pellaAPIURL}/rta/v2/salesforce/getCalendar`, {
				...config,
				params: params,
				...cancelToken,
			})
			.then((res) =>
				dispatch(
					{
						type: GET_CALENDAR_INFO,
						payload: res.data,
					},
					calendarTimings()
				)
			)
			.catch((err) => {
				dispatch(
					{
						type: GET_ERRORS,
						payload: err,
					},
					calendarError(params, err)
				);
			});
	};

const postEloquaData = (customerData) => {
	if (customerData.apptsource && customerData.apptsource.toLowerCase() === 'web') {
		const cookies = new Cookies();
		const eloquaConfig = {
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded',
			},
		};
		// Grab ELOQUA cookie value, split it and pop it to remove GUID=
		const guid = cookies.get('ELOQUA');
		const guidValue = guid != null ? guid.split('=').pop() : '';
		const eloquaData = {
			elqFormName: 'pella.com-rta',
			elqSiteID: '1920192983',
			elqCookieWrite: 0,
		};
		eloquaData.elqCustomerGUID = guidValue;
		const data = { ...customerData, ...eloquaData }; // New object, do not modify original object
		interceptorInstanceNonAuth.post(eloquaTrackingUrl, qs.stringify(data), eloquaConfig).catch((err) => {});
	}
};

// POST
export const appointment = (customerData) => (dispatch) => {
	dispatch(clearErrors());
	if (customerData.appttype === 'RT') {
		const timeblockData = {
			oppNo: customerData.oppNo,
			start: customerData.start,
			end: customerData.end,
			type: 'Block',
			zipcode: customerData.zip,
			appType: customerData.virtualapptmt ? 'virtual' : 'home',
		};
		interceptorInstanceNonAuth
			.post(`${pellaAPIURL}/rta/v2/salesforce/ServicePOSTTimeblock`, timeblockData, config)
			.then((result) => {
				if (result.data && result.data.errorMessage === null) {
					// Posting Data to Eloqua - Do not need to know if this succeeded
					postEloquaData(customerData);
					interceptorInstanceNonAuth
						.post(`${pellaAPIURL}/rta/v2/salesforce/PostRTA`, customerData, config)
						.then((res) =>
							dispatch({
								type: APPOINTMENT,
								payload: { AppointmentStatus: res.data },
							})
						)
						.catch((err) => {
							let errorObject = {
								submitError: true,
							};
							if (err.response) {
								// Status Code not 2xx
								errorObject.error = err.response;
							} else if (err.request) {
								// No response received
								errorObject.error = err.request;
							} else {
								errorObject.error = err.message;
							}
							dispatch({
								type: SUBMIT_APPOINTMENT_ERROR,
								payload: errorObject,
							});
						});
				} else {
					dispatch({
						type: TIMEBLOCK,
						payload: result.data,
					});
				}
			})
			.catch((err) =>
				dispatch({
					type: GET_ERRORS,
					payload: err,
				})
			);
	} else {
		interceptorInstanceNonAuth
			.post(`${pellaAPIURL}/rta/v2/salesforce/PostRTA`, customerData, config)
			.then((res) =>
				dispatch({
					type: APPOINTMENT,
					payload: { AppointmentStatus: res.data },
				})
			)
			.catch((err) => {
				let errorObject = {
					submitError: true,
				};
				if (err.response) {
					// Status Code not 2xx
					errorObject.error = err.response;
				} else if (err.request) {
					// No response received
					errorObject.error = err.request;
				} else {
					errorObject.error = err.message;
				}
				dispatch({
					type: SUBMIT_APPOINTMENT_ERROR,
					payload: errorObject,
				});
			});
	}
};

// Call center work around
export const callCenterAppointment = (customerData) => (dispatch) => {
	dispatch(clearErrors());
	if (customerData.appttype === 'RT') {
		const timeblockData = {
			oppNo: customerData.oppNo,
			start: customerData.start,
			end: customerData.end,
			type: 'Block',
			zipcode: customerData.postcode,
			appType: customerData.virtualapptmt ? 'virtual' : 'home',
		};
		interceptorInstanceNonAuth
			.post(`${pellaAPIURL}/rta/v2/salesforce/ServicePOSTTimeblock`, timeblockData, config)
			.then((result) => {
				if (result.data && result.data.errorMessage === null) {
					interceptorInstanceNonAuth
						.post(`${pellaAPIURL}/rta/v2/appointment/call/appointment`, customerData, config)
						// .post(`http://localhost:4000/rta/v2/appointment/call/appointment`, customerData, config)
						.then((res) =>
							dispatch({
								type: CALL_CENTER_APPOINTMENT,
								payload: { AppointmentStatus: res.data },
							})
						)
						.catch((err) =>
							dispatch({
								type: GET_ERRORS,
								payload: err,
							})
						);
				} else {
					dispatch({
						type: TIMEBLOCK,
						payload: result.data,
					});
				}
			})
			.catch((err) =>
				dispatch({
					type: GET_ERRORS,
					payload: err,
				})
			);
	} else {
		interceptorInstanceNonAuth
			.post(`${pellaAPIURL}/rta/v2/appointment/call/appointment`, customerData, config)
			// .post(`http://localhost:4000/rta/v2/appointment/call/appointment`, customerData, config)
			.then((res) =>
				dispatch({
					type: CALL_CENTER_APPOINTMENT,
					payload: { AppointmentStatus: res.data },
				})
			)
			.catch((err) =>
				dispatch({
					type: GET_ERRORS,
					payload: err,
				})
			);
	}
};

export const timeblock = (customerData) => (dispatch) => {
	dispatch(clearErrors());
	interceptorInstanceNonAuth
		.post(`${pellaAPIURL}/rta/v2/salesforce/ServicePOSTTimeblock`, customerData, config)
		.then((res) =>
			dispatch({
				type: TIMEBLOCK,
				payload: res.data,
			})
		)
		.catch((err) =>
			dispatch({
				type: GET_ERRORS,
				payload: err,
			})
		);
};

export const convertLead = (leadData) => (dispatch) => {
	dispatch(clearErrors());
	interceptorInstanceNonAuth
		.post(`${pellaAPIURL}/rta/v2/salesforce/ConvertLead`, leadData, config)
		.then((res) =>
			dispatch({
				type: CONVERT_LEAD,
				payload: { AppointmentStatus: res.data },
			})
		)
		.catch((err) => {
			let errorObject = {
				submitError: true,
			};
			if (err.response) {
				// Status Code not 2xx
				errorObject.error = err.response;
			} else if (err.request) {
				// No response received
				errorObject.error = err.request;
			} else {
				errorObject.error = err.message;
			}
			dispatch({
				type: SUBMIT_APPOINTMENT_CHANGE_ERROR,
				payload: errorObject,
			});
		});
};

export const storeAppointment = (appointmentData) => (dispatch) => {
	dispatch(clearErrors());
	interceptorInstanceNonAuth
		.post(`${pellaAPIURL}/rta/v2/temp/store-appointment`, appointmentData, config)
		.then((res) =>
			dispatch({
				type: STORE_APPOINTMENT,
				payload: res.data,
			})
		)
		.catch((err) =>
			dispatch({
				type: GET_ERRORS,
				payload: err,
			})
		);
};

export const storeLeadConvert = (appointmentData) => (dispatch) => {
	dispatch(clearErrors());
	interceptorInstanceNonAuth
		.post(`${pellaAPIURL}/rta/v2/temp/store-lead-convert`, appointmentData, config)
		.then((res) =>
			dispatch({
				type: STORE_LEAD_CONVERT,
				payload: res.data,
			})
		)
		.catch((err) =>
			dispatch({
				type: GET_ERRORS,
				payload: err,
			})
		);
};

// Don't use redux, but is an RTA action
export const downloadAppointmentPDF = (customerData) => {
	if (document.getElementById('pdfLink')) {
		document.getElementById('pdfLink').click();
	} else {
		interceptorInstanceNonAuth
			.post(`${pellaAPIURL}/rta/v2/pdf/appointment-pdf`, customerData, {
				...config,
				responseType: 'blob',
			})
			// .post(`http://localhost:4000/rta/pdf/appointment-pdf`, customerData, {...config, responseType: 'blob'})
			.then((res) => {
				const file = new Blob([res.data], { type: 'application/pdf' });
				const fileURL = URL.createObjectURL(file);
				const anchor = document.createElement('a');
				anchor.id = 'pdfLink';
				anchor.href = fileURL;
				anchor.target = '_blank';
				anchor.download = 'Pella-Appointment.pdf';
				anchor.style.display = 'none';
				document.getElementById('pdfLinkDiv').appendChild(anchor);
				anchor.click();
			})
			.catch((err) => {});
	}
};

// Initialize TechSee Visual Journey
export const initVisualJourney = (phone, customerID) =>
	new Promise(async (resolve) => {
		try {
			const body = {};

			if (phone) {
				body.countryCode = '1';
				body.phone = phone;
			}
			if (customerID) {
				body.customerID = customerID;
			}

			const res = await interceptorInstanceNonAuth.post(`${pellaAPIURL}/rta/v2/service-appointments/visual-journey`, body, config);
			resolve(res);
		} catch (error) {
			if (error.response && error.response.data) {
				resolve(error.response.data);
			} else {
				resolve({ success: false });
			}
		}
	});

// Get Service Calendar
export const getServiceCalendar = (slug) =>
	new Promise(async (resolve) => {
		try {
			const res = await interceptorInstanceNonAuth.get(`${pellaAPIURL}/rta/v2/service-appointments/calendar/${slug}`, config);
			resolve(res);
		} catch (error) {
			if (error.response && error.response.data) {
				resolve(error.response.data);
			} else {
				resolve({ success: false });
			}
		}
	});

// Block Service Calendar Timeslot
export const submitServiceAppointment = (apptData) =>
	new Promise(async (resolve) => {
		try {
			const res = await interceptorInstanceNonAuth.post(`${pellaAPIURL}/rta/v2/service-appointments/visual-journey/appointment`, apptData, config);
			resolve(res);
		} catch (error) {
			if (error.response && error.response.data) {
				resolve(error.response.data);
			} else {
				resolve({ success: false });
			}
		}
	});

// Clear errors
export const clearErrors = () => ({
	type: CLEAR_ERRORS,
});

// Reset rta data
export const resetRTACalls = () => ({
	type: RESET_RTA_DATA,
});
